// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__C5uDh","footer":"styles_footer__37unD","passCodeTooltip":"styles_passCodeTooltip__3Xnjg"};